export const LAST_LOADED = 'LAST_LOADED';
